import { useQuery } from '@tanstack/react-query';
import { getPillarDetail } from '../services/modeService';
import { PillarDetailResponse } from '../types/mode.types';

export const usePillarDetail = (siteId: number, pillarId: string) => {
  return useQuery<PillarDetailResponse>({
    queryKey: ['pillarDetail', siteId, pillarId],
    queryFn: () => getPillarDetail(siteId, pillarId),
    enabled: !!siteId && !!pillarId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
